<template>
  <div class="flex flex-wrap justify-center max-w-5xl mx-auto">
    <SeoBlock
      v-for="(box, index) in industryBoxes"
      :key="`industry-box-${index}`"
      v-bind="box"
      class="m-2"
    ></SeoBlock>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import SeoBlock from '@/components/SeoBlock.vue';

import { industryBoxes } from '@/modules/InformationPages/Industries/mocks/index.js';

export default defineComponent({
  name: 'IndustryGrid',
  components: { SeoBlock },
  setup() {
    return {
      industryBoxes,
    };
  },
});
</script>
